import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { ComponentProps } from 'react';
import { defineMessage, useIntl } from 'react-intl';

export const versionFieldMessage = defineMessage({
  id: 'audit.props.version',
  defaultMessage: 'Versión',
});

type VersionFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by version.
 */
export function VersionField({
  name = 'version',
  submitOnClear = true,
  label,
  ...props
}: VersionFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(versionFieldMessage)}
      {...props}
    />
  );
}
